import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=7c7e4e3c&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=js&"
export * from "./NewsArticle.vue?vue&type=script&lang=js&"
import style0 from "./NewsArticle.vue?vue&type=style&index=0&id=7c7e4e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e4e3c",
  null
  
)

export default component.exports